import ticketAccountService from '../../services/tickets/ticketaccount.service.js'

import httpUtility from '../../utils/http.utility.js'

import { useToast } from '../../composables/useToast.js'

import { t } from '@/i18n'

const toast = useToast()

async function getTicketAccountSettings(accountId, { silent = false } = {}) {
  try {
    const params = accountId ? { accountId: String(accountId) } : undefined
    return await ticketAccountService.get.settings(params)
  } catch (err) {
    if (!silent) {
      toast.error(httpUtility.error.message(err, t('tickets.settings.errors.loadConfig')))
    }
    return null
  }
}

class TicketAccountController {
  get = {
    /**
     * Load ticket settings for an account scope. Returns the settings
     * document on success, `null` on failure (toasts the error unless
     * `silent` is true).
     *
     * @param {string|null|undefined} [accountId]
     * @param {{ silent?: boolean }} [opts]
     * @returns {Promise<object|null>}
     */
    async settings(accountId, opts) {
      return getTicketAccountSettings(accountId, opts)
    },
  }
}

export default new TicketAccountController()
